import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadCities, loadCitiesFailure, loadCitiesSuccess } from './cities.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { ApplicationUsersService } from '@services';
import { ICity } from '@interfaces';

@Injectable()
export class CitiesEffect {
  constructor(
    private actions$: Actions,
    private _toast: ToastrService,
    private applicationUsersService: ApplicationUsersService,
  ) {}
  loadCities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCities),
      mergeMap(() =>
        this.applicationUsersService.getCityList().pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const cities = response.data.map((item: ICity) => ({
                id: item._id,
                name: item.cityName,
              }));
              return loadCitiesSuccess({ cities });
            } else {
              this._toast.error(response.message);
              return loadCitiesFailure({ error: '[Cities] Load Cities Failure' });
            }
          }),
          catchError((error) => {
            this._toast.error(error || error.message);
            return of(loadCitiesFailure({ error: '[Cities] Load Cities Failure' }));
          }),
        ),
      ),
    ),
  );
}
